import BaseRepository from '@repositories/desktop/BaseRepository';
import AjaxService from '@services/AjaxService';
import UrlParameterInterface from '@repositories/UrlParameterInterface';

export default class DesktopMessageRepository extends BaseRepository {
  protected baseUrl = '';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService)
  }
  public delete(messageId: number): Promise<any> {
    const url = '/api/desktop/messages/' + messageId;
    return this.ajaxService.sendDelete(url);
  }
  public forward(messageId: string, tab = 'undeleted'): Promise<any> {
    const url = '/api/desktop/messages/' + messageId + '/forward/' + tab;
    return this.ajaxService.postJson(url, {});
  }
  public markAllCompleted(parameters: UrlParameterInterface): Promise<any> {
    const url = '/api/desktop/messages/mark-all-completed';
    return this.ajaxService.postJson(url, parameters);
  }
  public markCompleted(messageId: string): Promise<any> {
    const url = '/api/desktop/messages/' + messageId + '/mark-completed';
    return this.ajaxService.postJson(url, {});
  }
  public markNotCompleted(messageId: string): Promise<any> {
    const url = '/api/desktop/messages/' + messageId + '/mark-not-completed';
    return this.ajaxService.postJson(url, {});
  }
  public markNotRead(messageId: string): Promise<any> {
    const url = '/api/desktop/messages/' + messageId + '/mark-not-read';
    return this.ajaxService.postJson(url, {});
  }
  public show(messageId: string, tab = 'undeleted'): Promise<any> {
    const url = '/api/desktop/messages/' + messageId + '/' + tab;
    return this.ajaxService.getJson(url);
  }
}
